// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Drdq","row":"ProcedureTreatmentSummary_row__3APy5"};